var map = {
	"./150-rubles.svg": 1527,
	"./500-rubles.svg": 1528,
	"./ai-girl.jpg": 1529,
	"./apple-logo.svg": 1530,
	"./arrow-green.png": 739,
	"./arrow-white.png": 740,
	"./arrow.svg": 1531,
	"./arrows-down.webp": 942,
	"./avatars/cool_man.jpg": 724,
	"./avatars/creeper.jpg": 725,
	"./avatars/creeper_and_bomb.jpg": 726,
	"./avatars/creeper_head.jpg": 727,
	"./avatars/default.jpg": 602,
	"./avatars/happy.jpg": 728,
	"./avatars/happy_robot.jpg": 729,
	"./avatars/logo.jpg": 730,
	"./avatars/man.jpg": 731,
	"./avatars/neutral.jpg": 732,
	"./avatars/sad.jpg": 733,
	"./boy-three.jpg": 1532,
	"./boy-two.jpg": 1533,
	"./boy.jpg": 1534,
	"./brand_block.svg": 1535,
	"./cake-two.png": 741,
	"./cake.png": 742,
	"./check.svg": 1536,
	"./creeper-one.png": 743,
	"./creeper-two.png": 744,
	"./discord-banner.png": 745,
	"./discount-banner.jpg": 1537,
	"./dollar.svg": 1538,
	"./dolyame.svg": 857,
	"./dragon-one.png": 746,
	"./dragon-two.png": 747,
	"./facebook.png": 748,
	"./favicon.ico": 1539,
	"./footer.jpg": 1540,
	"./girl-three.jpg": 1541,
	"./girl-two.jpg": 1542,
	"./google.png": 749,
	"./guide-girl.png": 615,
	"./guide-modal.jpg": 1543,
	"./hero-python-one.jpg": 1544,
	"./hero-snap-one.jpg": 1545,
	"./hero-snap-three.jpg": 1546,
	"./hero-snap-two.jpg": 1547,
	"./hero.jpg": 1548,
	"./hero2.png": 750,
	"./heroes-one.png": 751,
	"./heroes-three.png": 752,
	"./heroes-two.png": 753,
	"./horse.png": 616,
	"./house.png": 754,
	"./icon-about.svg": 1549,
	"./icon-btc.svg": 858,
	"./icon-dogecoin.svg": 859,
	"./icon-parents.svg": 1550,
	"./icon-partners.svg": 1551,
	"./icons/badge-orange.png": 755,
	"./icons/course-available.png": 617,
	"./icons/course-not-available.png": 618,
	"./icons/course-not-subscribed.png": 619,
	"./icons/emerald.png": 756,
	"./icons/medal.png": 620,
	"./icons/pickaxe-code.png": 621,
	"./icons/pickaxe-plain.png": 622,
	"./icons/pickaxe-scratch.png": 623,
	"./icons/pickaxe-snap-classic.png": 624,
	"./icons/pickaxe-snap.png": 625,
	"./icons/rub.png": 757,
	"./icons/sword-diamond.png": 626,
	"./icons/sword-iron.png": 627,
	"./icons/sword-wood.png": 628,
	"./kids.png": 758,
	"./landing/arrow.svg": 1552,
	"./landing/boy-head.png": 759,
	"./landing/boy.png": 760,
	"./landing/check.svg": 1553,
	"./landing/download.svg": 1554,
	"./landing/girl.png": 761,
	"./landing/icon-about.svg": 1555,
	"./landing/icon-parents.svg": 1556,
	"./landing/icon-partners.svg": 1557,
	"./landing/kids.png": 762,
	"./landing/learning-1.svg": 1558,
	"./landing/learning-2.svg": 1559,
	"./landing/learning-3.svg": 1560,
	"./landing/monitor.png": 763,
	"./landing/my-courses.svg": 1561,
	"./landing/notebook.png": 764,
	"./landing/phrase-eureka.svg": 1562,
	"./landing/phrase-waiting.svg": 1563,
	"./landing/phrase-welcome.svg": 1564,
	"./landing/robot-eureka.svg": 1565,
	"./landing/robot-head.svg": 835,
	"./landing/robot-waiting.svg": 943,
	"./landing/robot-welcome.svg": 1566,
	"./landings/bg/code-bg.png": 765,
	"./landings/bg/code-gray-bg.png": 766,
	"./landings/bg/code-green-bg.png": 767,
	"./landings/bg/header_bg.png": 768,
	"./landings/bg/header_girl.png": 769,
	"./landings/bg/header_parent.png": 770,
	"./landings/bg/header_phrases.png": 771,
	"./landings/bg/minecraft-1.png": 772,
	"./landings/bg/minecraft-2.png": 773,
	"./landings/bg/minecraft-3.png": 774,
	"./landings/bg/quote-black.png": 775,
	"./landings/bg/what_left.png": 776,
	"./landings/bg/what_right.png": 777,
	"./landings/blocks/column.png": 778,
	"./landings/blocks/spawn.png": 779,
	"./landings/blocks/start.png": 780,
	"./landings/blocks/weather.png": 781,
	"./landings/boy-bg.png": 782,
	"./landings/boy-standing.png": 783,
	"./landings/boy.png": 784,
	"./landings/check.png": 785,
	"./landings/cube.png": 786,
	"./landings/dash-0.svg": 1567,
	"./landings/dash-1.svg": 1568,
	"./landings/dash-2.svg": 1569,
	"./landings/girl.png": 787,
	"./landings/heart.png": 788,
	"./landings/hero-fighting.png": 789,
	"./landings/hero-standing.png": 790,
	"./landings/icon-0.png": 791,
	"./landings/icon-1.png": 792,
	"./landings/icon-2.png": 793,
	"./landings/icon-3.png": 794,
	"./landings/logo-grayscale.png": 504,
	"./landings/logo-parents.png": 612,
	"./landings/logo.png": 503,
	"./landings/minecraft-example.gif": 1570,
	"./landings/minus.png": 795,
	"./landings/quote.png": 796,
	"./landings/snap-example.png": 797,
	"./landings/teacher-standing.png": 798,
	"./landings/tick.png": 799,
	"./linux-logo.svg": 1571,
	"./lock-gold.svg": 1572,
	"./lock-open.svg": 1573,
	"./lock.svg": 1574,
	"./logo-ai.svg": 1575,
	"./logo-default.svg": 1576,
	"./logo-white.png": 800,
	"./mascot.png": 801,
	"./ml.png": 802,
	"./modal.jpg": 1577,
	"./new/bg_minecraft-1.jpg": 1578,
	"./new/bg_minecraft-one.png": 803,
	"./new/bg_minecraft-sun0.png": 804,
	"./new/bg_minecraft-sun1.png": 805,
	"./new/bg_minecraft-two.png": 806,
	"./new/bg_minecraft.jpg": 1579,
	"./new/block-1_bg.jpg": 1580,
	"./new/icon-1.png": 807,
	"./new/icon-2.png": 808,
	"./new/icon-3.png": 809,
	"./new/icon-4.png": 810,
	"./new/kid.png": 811,
	"./new/logo.png": 812,
	"./new/monitor-shadow.png": 813,
	"./new/monitor-shine.png": 814,
	"./new/monitor.png": 815,
	"./orange-and-white.svg": 1581,
	"./partners/codim.png": 816,
	"./partners/vikids.png": 817,
	"./partners/vsepravilno.jpg": 1582,
	"./pig.png": 818,
	"./pixels.png": 819,
	"./present.png": 820,
	"./python-big.png": 821,
	"./python.png": 613,
	"./python_old.png": 822,
	"./robot-green-1-up.svg": 1583,
	"./robot-green-1.svg": 1584,
	"./robot-green-full.svg": 1585,
	"./robot-green-happy-head.svg": 450,
	"./robot-green-happy.svg": 1586,
	"./robot-head.svg": 1587,
	"./robot-orange-1-up.svg": 1588,
	"./robot-orange-1.svg": 1589,
	"./robot-orange-broken.svg": 1590,
	"./robot-orange-full.svg": 1591,
	"./robot-orange-happy-head.svg": 1592,
	"./robot-red-happy-head.svg": 1593,
	"./schools/2123_mskobr.png": 603,
	"./schools/26_mbou.png": 604,
	"./schools/kodini.png": 605,
	"./schools/metallurg.png": 606,
	"./schools/o-brain.png": 607,
	"./schools/qtime.png": 608,
	"./schools/qtime_estonia.png": 609,
	"./schools/robotorium.png": 610,
	"./scratch-logo.svg": 513,
	"./snap-axe.png": 823,
	"./snap-big.png": 824,
	"./snap-pickaxe.png": 825,
	"./snap-shovel.png": 826,
	"./snap.png": 827,
	"./snap.svg": 1594,
	"./snap_old.png": 828,
	"./special-offer-title.svg": 1595,
	"./tinkercad.png": 240,
	"./tinkoff.png": 829,
	"./torch.png": 830,
	"./tree-two.png": 831,
	"./tree.png": 832,
	"./vk.png": 833,
	"./windows-logo.svg": 1596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1526;